<template>
  <!-- Modal Overlay -->
  <Teleport to="body">
    <div
      v-if="visible"
      id="modal"
      class="animate__fadeIn animate__animated animate__faster tw-fixed tw-flex tw-w-full tw-inset-0  tw-justify-center tw-z-[999999] tw-bg-[rgba(0,0,0,0.50)] tw-backdrop-blur-[16px]"
    >
      <!-- Modal Content -->
      <div
        id="modal-content"
        class="animate__fadeInUp animate__animated tw-bg-white dark:tw-bg-ap-nero dark:tw-text-ap-white tw-flex tw-flex-col tw-max-w-[960px] tw-w-full apTablet:tw-mx-20 tw-mt-20 apTablet:tw-my-20 tw-rounded-[20px] tw-rounded-b-none apTablet:tw-rounded-[20px] animate__animated"
        :class="{ 'apTablet:tw-my-auto': fitContent }"
      >
        <!-- Close Button -->
        <div class="tw-w-full tw-flex tw-justify-end tw-px-2 tablet:tw-px-5 tw-py-5">
          <img
            :src="$cdn('icons/shared/ic_close.png')"
            alt="ic_close"
            class="tw-w-[32px] tablet:tw-w-[40px] tw-h-20px tablet:tw-h-[40px] hover:tw-cursor-pointer hover:tw-opacity-80 tw-bg-white dark:tw-bg-ap-nero tw-rounded-full"
            @click="closeModal"
          >
        </div>
        <slot />
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts">
export default {
  name: 'teleport-modal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    fitContent: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    closeModal() {

      const modal = document.getElementById('modal-content');
      const background = document.getElementById('modal');
      if (modal && background) {
        modal.classList.remove('animate__fadeInUp');
        modal.classList.add('animate__fadeOutDown');
        background.classList.remove('animate__fadeIn');
        background.classList.add('animate__fadeOut');
        setTimeout(() => {
          modal.classList.remove('animate__fadeOutDown');
          this.$emit('update:visible', false);
          // Allow body to scroll when modal is closed
          document.body.style.overflow = 'auto';
        }, 300);
      }
    },
  },
};
</script>

<style scoped>
#modal-content {
  animation-duration: 300ms !important;
}

</style>